import {ChatPopout} from '../popouts/chat_popout'
import {ContactPopout} from '../popouts/contact_popout'

export const getPopoutComponent = props => {
	const {chat, contact, PopoutComponent} = props
	if (PopoutComponent) return PopoutComponent
	if (chat) return ChatPopout
	if (contact) return ContactPopout
}
